import { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      try {
        const user = await authService.getCurrentUser();
        if (user && user.role) {
          setCurrentUser(user);
          setUserRole(user.role.nom_role);
        } else {
          setCurrentUser(null);
          setUserRole(null);
          authService.setToken(null);
        }
      } catch (error) {
        console.error('Erreur d\'authentification:', error);
        setCurrentUser(null);
        setUserRole(null);
        authService.setToken(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const value = {
    currentUser,
    userRole,
    loading,
    setCurrentUser,
    setUserRole
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 